export const bloodGroupOptions = [
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' },
  { value: 'Not Sure', label: 'Not Sure' }
]

export const classOptions = [
  { value: 0, label: 'UKG' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' }
]

export const genderOptions = [{ label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' }]

export const relationshipOptions = [
  { value: 'Mother', label: 'Mother' },
  { value: 'Father', label: 'Father' },
  { value: 'Guardian', label: 'Guardian' }
]

export const levelOptions = [
  { value: 'Beginner', label: 'Beginner' },
  { value: 'Intermediate', label: 'Intermediate' },
  { value: 'Expert', label: 'Expert' }
]

export const orgTypeOptions = [
  { label: 'Educational Institution', value: 'EDU' },
  { label: 'Private Sports Venue', value: 'PRIVATE' },
  { label: 'Sports Academy', value: 'ACADEMY' }
]

export const memTypeOptions = [
  { label: 'Student', value: 'STUDENT', id: 0 },
  { label: 'Alumni', value: 'ALUMNI', id: 1 },
  { label: 'Member', value: 'MEMBER', id: 2 }
]

export const memStatusOptions = [
  { label: 'Verified', value: 'VERIFIED' },
  { label: 'Pending Verification', value: 'PENDING' },
  { label: 'Rejected', value: 'REJECTED' }
]

export const accTypeOptions = [
  { label: 'Current', value: 'CURRENT' },
  { label: 'Savings', value: 'SAVING' }
]

export const gstStatusOptions = [
  { label: '18%', value: 'PERCENT_18' },
  { label: 'Composite', value: 'COMPOSITE' },
  { label: 'Not Registered', value: 'NOT_REGD' }
]

export const fieldTypeOptions = [
  { value: '50mm Artificial Grass', label: '50mm Artificial Grass' },
  { value: 'Artificial Grass', label: 'Artificial Grass' },
  { value: 'Board', label: 'Board' },
  { value: 'Cement', label: 'Cement' },
  { value: 'Clay', label: 'Clay' },
  { value: 'Concrete', label: 'Concrete' },
  { value: 'Concrete Pitch', label: 'Concrete Pitch' },
  { value: 'Grass', label: 'Grass' },
  { value: 'Grass Ground', label: 'Grass Ground' },
  { value: 'Grass/Mud w Pitch', label: 'Grass/Mud w Pitch' },
  { value: 'Grass Turf', label: 'Grass Turf' },
  { value: 'Mud', label: 'Mud' },
  { value: 'Mud Ground', label: 'Mud Ground' },
  { value: 'Mud/Sand', label: 'Mud/Sand' },
  { value: 'Natural Grass', label: 'Natural Grass' },
  { value: 'Sand', label: 'Sand' },
  { value: 'Synthetic', label: 'Synthetic' },
  { value: 'Synthetic Court', label: 'Synthetic Court' },
  { value: 'Synthetic Floor', label: 'Synthetic Floor' },
  { value: 'Turf', label: 'Turf' },
  { value: 'Turf Pitch', label: 'Turf Pitch' },
  { value: 'Wooden', label: 'Wooden' },
  { value: 'Wooden - Non-marking shoes only', label: 'Wooden - Non-marking shoes only' }
]

export const fieldIdealForOptions = [
  { value: 'All Levels', label: 'All Levels' },
  { value: 'All Levels, Strictly Non Marking Shoes', label: 'All Levels, Strictly Non Marking Shoes' },
  { value: 'Amateur & Intermediate', label: 'Amateur & Intermediate' },
  { value: 'Singles', label: 'Singles' },
  { value: '2 players', label: '2 players' },
  { value: 'Futsal 5-a-side or Box Cricket 6v6', label: 'Futsal 5-a-side or Box Cricket 6v6' },
  { value: 'Futsal 5-a-side or Box Cricket 7v7', label: 'Futsal 5-a-side or Box Cricket 7v7' },
  { value: 'Futsal 5-a-side or Box Cricket 8v8', label: 'Futsal 5-a-side or Box Cricket 8v8' },
  { value: 'Football or Cricket, 11-a-side', label: 'Football or Cricket, 11-a-side' },
  { value: 'Football', label: 'Football' },
  { value: 'Tennis & Pickleball', label: 'Tennis & Pickleball' },
  { value: 'Football, Cricket, All levels', label: 'Football, Cricket, All levels' },
  { value: 'Professional (4hour slots)', label: 'Professional (4hour slots)' },
  { value: 'Football & Box Cricket', label: 'Football & Box Cricket' },
  { value: 'Futsal & Box Cricket', label: 'Futsal & Box Cricket' },
  { value: 'Football & Cricket', label: 'Football & Cricket' },
  { value: '5-a-side', label: '5-a-side' },
  { value: '7-a-side', label: '7-a-side' },
  { value: '9-a-side', label: '9-a-side' },
  { value: '11-a-side', label: '11-a-side' },
  { value: '8 vs 8', label: '8 vs 8' },
  { value: '6 vs 6', label: '6 vs 6' },
  { value: 'U13 Matches, Tennis Ball Cricket', label: 'U13 Matches, Tennis Ball Cricket' },
  { value: 'not in use', label: 'not in use' }
]

export const fieldMultiNumberOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
  { value: 13, label: '13' },
  { value: 14, label: '14' },
  { value: 15, label: '15' },
  { value: 16, label: '16' },
  { value: 17, label: '17' },
  { value: 18, label: '18' },
  { value: 19, label: '19' },
  { value: 20, label: '20' }
]

export const dowOptions = [
  { value: 0, label: 'Monday' },
  { value: 1, label: 'Tuesday' },
  { value: 2, label: 'Wednesday' },
  { value: 3, label: 'Thursday' },
  { value: 4, label: 'Friday' },
  { value: 5, label: 'Saturday' },
  { value: 6, label: 'Sunday' }
]

export const prgAudienceTypes = [{ value: 'public', label: 'Public' }, { value: 'internal', label: 'Internal' }]

export const prgTypes = [{ value: 'fixed', label: 'Fixed Duration' }, { value: 'continuous', label: 'Continuous' }, { value: 'flexi', label: 'Continuous Flexi' }]

export const prgPayTypes = [
  { value: 'prepaid', label: 'Prepaid', type: 'fixed' },
  { value: 'monthsplit', label: 'Monthly Split', type: 'fixed' },
  { value: 'monthly', label: 'Monthly', type: 'continuous' },
  { value: 'quarterly', label: 'Quarterly', type: 'continuous' },
  { value: 'halfyearly', label: 'Half-yearly', type: 'continuous' },
  { value: 'annual', label: 'Annual', type: 'continuous' },
  { value: 'w1sessions', label: '1 weekly session (Monthly)', type: 'flexi' },
  { value: 'w2sessions', label: '2 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w3sessions', label: '3 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w4sessions', label: '4 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w5sessions', label: '5 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w6sessions', label: '6 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w7sessions', label: '7 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w8sessions', label: '8 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w9sessions', label: '9 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w10sessions', label: '10 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w11sessions', label: '11 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w12sessions', label: '12 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w13sessions', label: '13 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w14sessions', label: '14 weekly sessions (Monthly)', type: 'flexi' },
  { value: 'w1sessionsquarterly', label: '1 weekly session (Quarterly)', type: 'flexiquarterly' },
  { value: 'w2sessionsquarterly', label: '2 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w3sessionsquarterly', label: '3 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w4sessionsquarterly', label: '4 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w5sessionsquarterly', label: '5 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w6sessionsquarterly', label: '6 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w7sessionsquarterly', label: '7 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w8sessionsquarterly', label: '8 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w9sessionsquarterly', label: '9 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w10sessionsquarterly', label: '10 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w11sessionsquarterly', label: '11 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w12sessionsquarterly', label: '12 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w13sessionsquarterly', label: '13 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w14sessionsquarterly', label: '14 weekly sessions (Quarterly)', type: 'flexiquarterly' },
  { value: 'w1sessionshalfyearly', label: '1 weekly session (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w2sessionshalfyearly', label: '2 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w3sessionshalfyearly', label: '3 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w4sessionshalfyearly', label: '4 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w5sessionshalfyearly', label: '5 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w6sessionshalfyearly', label: '6 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w7sessionshalfyearly', label: '7 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w8sessionshalfyearly', label: '8 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w9sessionshalfyearly', label: '9 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w10sessionshalfyearly', label: '10 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w11sessionshalfyearly', label: '11 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w12sessionshalfyearly', label: '12 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w13sessionshalfyearly', label: '13 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w14sessionshalfyearly', label: '14 weekly sessions (Half-yearly)', type: 'flexihalfyearly' },
  { value: 'w1sessionsannual', label: '1 weekly session (Annual)', type: 'flexiannual' },
  { value: 'w2sessionsannual', label: '2 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w3sessionsannual', label: '3 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w4sessionsannual', label: '4 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w5sessionsannual', label: '5 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w6sessionsannual', label: '6 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w7sessionsannual', label: '7 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w8sessionsannual', label: '8 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w9sessionsannual', label: '9 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w10sessionsannual', label: '10 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w11sessionsannual', label: '11 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w12sessionsannual', label: '12 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w13sessionsannual', label: '13 weekly sessions (Annual)', type: 'flexiannual' },
  { value: 'w14sessionsannual', label: '14 weekly sessions (Annual)', type: 'flexiannual' }
]

export const enrolStatus = {
  ENROLLED: { title: 'Enrolled', color: 'light-success' },
  DUE_SOON: { title: 'Due Soon', color: 'light-warning' },
  OVERDUE: { title: 'Overdue', color: 'light-danger' },
  PAUSED: { title: 'Paused', color: 'light-info' },
  CANCELLED: { title: 'Cancelled', color: 'light-secondary' },
  ARCHIVED: { title: 'Archived', color: 'light-secondary' },
  REFUNDED: { title: 'Refunded', color: 'light-danger' }
}

export const userTypes = [
  { label: 'Org Admin', value: 'orgadm', id: 0 },
  { label: 'Venue Admin', value: 'venueadm', id: 1 },
  { label: 'Fin Admin', value: 'finadm', id: 2 },
  { label: 'Marker', value: 'marker', id: 3 },
  { label: 'Coach', value: 'coach', id: 4 }
]

export const payTypes = [
  { value: 'CASH', label: 'Cash' },
  { value: 'QRSCAN', label: 'QR-Scan' },
  { value: 'UPI', label: 'UPI' },
  { value: 'CREDITCARD', label: 'CreditCard' },
  { value: 'NETBANKING', label: 'NetBanking' },
  { value: 'OTHER', label: 'Other' }
]

export const slotTypes = [
  { value: 'BOOKING', label: 'Booking' },
  { value: 'ALL_PLAY', label: 'AllPlay' },
  { value: 'MEMBERSHIP', label: 'Subscription' }
]

export const planDurations = [
  { value: 0, label: 'Annual' },
  { value: 1, label: 'HalfYearly' },
  { value: 2, label: 'Quarterly' },
  { value: 3, label: 'Monthly' }
]

export const planModules = [
  { value: 0, label: 'Play' },
  { value: 1, label: 'Learn' },
  { value: 2, label: 'Both' }
]

export const badgeColors = {
  0: 'light-warning',
  1: 'light-info',
  2: 'light-success',
  3: 'light-secondary',
  4: 'light-danger'
}
export const orgStatusColors = {
  PENDING: { title: 'PENDING', color: 'light-warning' },
  PUBLISHED: { title: 'PUBLISHED', color: 'light-success' },
  INACTIVE: { title: 'INACTIVE', color: 'light-danger' },
  ARCHIVED: { title: 'ARCHIVED', color: 'light-secondary' }
}

export const bookCalColors = {
  PAID: 'success',
  NEW: 'secondary',
  CANCELLED: 'secondary',
  REFUNDED: 'danger',
  COMPLETE: 'info',
  NOSHOW: 'danger',
  BOOKED: 'warning',
  PART_PAID: 'warning'
}

export const bookStatus = {
  NEW: { title: 'NEW', color: 'light-secondary' },
  BOOKED: { title: 'BOOKED', color: 'light-warning' },
  PART_PAID: { title: 'PART PAID', color: 'light-warning' },
  PAID: { title: 'PAID', color: 'light-success' },
  CANCELLED: { title: 'CANCELLED', color: 'light-secondary' },
  COMPLETE: { title: 'COMPLETE', color: 'light-info' },
  NOSHOW: { title: 'NOSHOW', color: 'light-danger' },
  REFUNDED: { title: 'REFUNDED', color: 'light-danger' },
  BLOCKED: { title: 'BLOCKED', color: 'light-secondary' }
}

export const subsTypes = [
  { value: 'fixed', label: 'Fixed Duration' },
  { value: 'continuous', label: 'Continuous' },
  { value: 'sessions', label: 'Sessions Based' }
]

export const subsPayTypes = [
  { value: 'prepaid', label: 'Prepaid', type: 'fixed' },
  { value: 'monthsplit', label: 'Monthly Split', type: 'fixed' },
  { value: 'monthly', label: 'Monthly', type: 'continuous' },
  { value: 'quarterly', label: 'Quarterly', type: 'continuous' },
  { value: 'halfyearly', label: 'Half-yearly', type: 'continuous' },
  { value: 'annual', label: 'Annual', type: 'continuous' }
]

export const subsStatus = {
  DUE_SOON: { title: 'Due Soon', color: 'light-warning' },
  ACTIVE: { title: 'Active', color: 'light-success' },
  OVERDUE: { title: 'Overdue', color: 'light-danger' },
  CANCELLED: { title: 'Cancelled', color: 'light-secondary' },
  ARCHIVED: { title: 'Archived', color: 'light-secondary' },
  REFUNDED: { title: 'Refunded', color: 'light-danger' },
  COMPLETED: { title: 'Completed', color: 'light-info' }
}

export const discTypes = [
  { value: 0, label: 'Booking', color: 'light-info' },
  { value: 1, label: 'Coaching', color: 'light-warning' },
  { value: 2, label: 'Subscription', color: 'light-secondary' }
]

export const discDurations = [
  { value: 0, label: 'Annual' },
  { value: 1, label: 'HalfYearly' },
  { value: 2, label: 'Quarterly' },
  { value: 3, label: 'Monthly' }
]

export const orgMetricOptions = [
  { value: 'NONE', label: 'No Metrics' },
  { value: 'SYSTEM', label: 'System Metrics only' },
  { value: 'ORG', label: 'Org Metrics' }
]

export const metricVisibilityOptions = [
  { value: 'MANUAL', label: 'On Publish' },
  { value: 'REALTIME', label: 'Realtime' }
  // { value: 'MONTHLY', label: 'Monthly' },
  // { value: 'QUARTERLY', label: 'Quarterly' },
  // { value: 'HALF_YEARLY', label: 'Half-Yearly' },
  // { value: 'ANNUAL', label: 'Annual' }
]

export const dateRanges = [
  { key: 'week', label: 'Last Week' },
  { key: 'month', label: 'Last Month' },
  { key: '3mon', label: 'Last 3 Months' },
  { key: 'custom', label: 'Custom' }
]
